export const GET_PRINT_TEMPLATE_BY_NAME = 'EPIC/GET_PRINT_TEMPLATE_BY_NAME';
export const GET_PRINT_TEMPLATE_BY_NAME_SUCCESS = 'EPIC/GET_PRINT_TEMPLATE_BY_NAME_SUCCESS';
export const GET_PRINT_TEMPLATE_BY_NAME_FAILURE = 'EPIC/GET_PRINT_TEMPLATE_BY_NAME_FAILURE';
